






































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import GeneralModule from '@/store/modules/General';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component
export default class WebManagementBody extends Mixins(ErrorHandleMixin) {
  GeneralInstance = getModule(GeneralModule, this.$store);

  isDelete = false;

  @Prop() readonly data: any;

  @Prop() readonly editData!: Function;

  @Prop() readonly deleteData!: Function;

  toggleDelte() {
    this.isDelete = !this.isDelete;
  }
}
